import { render, staticRenderFns } from "./PaidOrdersTable.vue?vue&type=template&id=12da658c&scoped=true"
import script from "./PaidOrdersTable.vue?vue&type=script&lang=js"
export * from "./PaidOrdersTable.vue?vue&type=script&lang=js"
import style0 from "./PaidOrdersTable.vue?vue&type=style&index=0&id=12da658c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12da658c",
  null
  
)

export default component.exports